import React from "react";
import { Box, Typography } from "@mui/material";
import { CheckCircle } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import GlassPanel from "./ui/GlassPanel";
import GradientMeshBackground from "./ui/GradientMeshBackground";
import MagneticButton from "./ui/MagneticButton";

export default function Hero8() {
  const navigate = useNavigate();

  return (
    <Box
      component="section"
      id="company-section"
      sx={{
        position: "relative",
        minHeight: { xs: "auto", md: 460 },
        overflow: "hidden",
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: "center",
        justifyContent: "space-between",
        px: { xs: 3, md: 10 },
        py: { xs: 6, md: 10 },
        color: "#fff",
        textAlign: { xs: "center", md: "left" },
        fontFamily: "Nunito, serif",
        background: "linear-gradient(150deg, #12121C 0%, #241511 60%, #C85E00 130%)",
      }}
    >
      <GradientMeshBackground
        blobs={[
          { size: 420, top: '-20%', left: '65%', color: 'rgba(253,129,18,0.4)', duration: 18 },
          { size: 260, top: '55%', left: '-10%', color: 'rgba(255,255,255,0.12)', duration: 24 },
        ]}
      />

      {/* Left Text */}
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.6 }}
        style={{ maxWidth: 600, width: "100%", position: "relative", zIndex: 1 }}
      >
        <Typography
          component="h2"
          variant="h4"
          sx={{
            fontWeight: "bold",
            mb: 2,
            fontSize: { xs: "1.5rem", md: "2rem" },
            fontFamily: "Poppins, sans-serif",
          }}
        >
          Transforming Ideas into Powerful Marketing Strategies—Let's Create Something Great!
        </Typography>
        <Typography
          variant="body1"
          sx={{ mb: 2, color: "rgba(255,255,255,0.75)", fontFamily: "Nunito, serif" }}
        >
          Partner with us to transform your marketing efforts.
        </Typography>
      </motion.div>

      {/* Floating Card */}
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.6, delay: 0.15 }}
        style={{
          width: "100%",
          maxWidth: 350,
          marginTop: 24,
          position: "relative",
          zIndex: 2,
        }}
      >
        <GlassPanel tone="dark" sx={{ p: 3 }}>
          <Typography variant="h6" sx={{ mb: 2, fontFamily: "Poppins, sans-serif", fontWeight: 600 }}>
            What You Will Gain
          </Typography>
          {[
            "Exceptional client experience",
            "Quick marketing support",
            "Complete marketing access",
          ].map((text, index) => (
            <Box key={index} sx={{ display: "flex", alignItems: "center", mb: 1 }}>
              <CheckCircle sx={{ fontSize: 20, color: "#FD8112", mr: 1 }} />
              <Typography variant="body2" sx={{ fontFamily: "Nunito, serif", color: "rgba(255,255,255,0.85)" }}>
                {text}
              </Typography>
            </Box>
          ))}

          <MagneticButton
            variant="contained"
            onClick={() => navigate("/requestquotes")}
            sx={{
              background: "linear-gradient(135deg, #FD8112, #FF5F6D)",
              color: "#fff",
              fontWeight: "bold",
              mt: 2,
              width: "100%",
              fontFamily: "Nunito, serif",
            }}
          >
            Contact Us / Request for Quotes
          </MagneticButton>
        </GlassPanel>
      </motion.div>
    </Box>
  );
}
